interface Props {
  shipsSum: bigint;
  sheepSum: bigint;
  N: bigint;
  doCelu: bigint;
  wynik: bigint;
  message: string;
  onSave?: () => void;
}

export function ResultBox({ shipsSum, sheepSum, wynik, doCelu, message }: Props) {
  const isPerfect = doCelu === 0n && wynik > 0n;
  const isEmpty = wynik === 0n;

  return (
    <div className="result-box">
      <div className="result-equation">
        <span className="val-ship">{shipsSum.toString()} 🚀</span>
        <span className="op">×</span>
        <span className="val-sheep">{sheepSum.toString()} 🐑</span>
        <span className="op">=</span>
        <span className="val-total">{wynik.toString()}</span>
      </div>

      {!isEmpty && (
        <div className="result-status">
          <span className={isPerfect ? "result-success" : "result-fail"}>
            {isPerfect
              ? "✔ Trafione!"
              : doCelu > 0n
                ? `Brakuje ${doCelu.toString()}`
                : `Przekroczono o ${(-doCelu).toString()}`}
          </span>
        </div>
      )}

      {message && <div className="result-message">{message}</div>}
    </div>
  );
}
